import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`py-10 md:py-24 ${dark ? 'bg-brand-dark text-white' : 'bg-white text-slate-900'} ${className}`} data-id="element-354">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-6xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-355">
        {children}
      </motion.div>
    </section>;
}